import { useEffect, useState } from "react";
import type { Theme } from "./theme";
import { DEFAULT_THEME, migrateLegacyThemeId, themes } from "./theme";

const THEME_KEY = "app-theme";

/** Chuẩn hóa giá trị lưu trữ — map id cũ + tránh khóa không tồn tại. */
const resolveStoredThemeId = (raw: string | null): Theme => {
  if (raw == null || raw === "") return DEFAULT_THEME;
  const migrated = migrateLegacyThemeId(raw);
  const candidate = migrated ?? raw;
  return candidate in themes ? (candidate as Theme) : DEFAULT_THEME;
};

const useThemeSwitcher = () => {
  const [currentTheme, setCurrentTheme] = useState<Theme>(() =>
    resolveStoredThemeId(localStorage.getItem(THEME_KEY)),
  );

  useEffect(() => {
    const root = document.documentElement;
    const effectiveTheme = resolveStoredThemeId(currentTheme);

    // State có thể còn id cũ nếu `themes` thay đổi phiên sau — chỉnh lại một lần
    if (effectiveTheme !== currentTheme) {
      setCurrentTheme(effectiveTheme);
      return;
    }

    const themeConfig = themes[effectiveTheme];
    if (!themeConfig) return;

    for (const [key, value] of Object.entries(themeConfig)) {
      root.style.setProperty(key, value as string);
    }

    root.setAttribute("data-theme", effectiveTheme);

    localStorage.setItem(THEME_KEY, effectiveTheme);
  }, [currentTheme]);

  const setTheme = (themeId: Theme) => {
    if (!(themeId in themes)) return;
    setCurrentTheme(themeId);
  };

  return { currentTheme, setTheme };
};

export default useThemeSwitcher;
